import { isNumber, isString } from "lodash";
import moment from "moment";

export function fallbackCopyTextToClipboard(text, success, fail) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand("copy");
        successful ? success() : fail();
    } catch (err) {
        fail(err);
    }

    document.body.removeChild(textArea);
}

export function copyTextToClipboard({ text, success = () => "", fail = () => "" }) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text, success, fail);
        return;
    }
    navigator.clipboard.writeText(text).then(success, fail);
}

export function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

export function getDomenFromUrl(str) {
    if (!isString(str)) return "";

    str = str.replace("https://", "");
    str = str.replace("http://", "");
    str = str.replace("www.", "");

    const firstSlesh = str.indexOf("/");
    if (firstSlesh > -1) return str.slice(0, firstSlesh);

    return str;
}

export function increase(num, value = 1) {
    const val = isNumber(value) ? value : 0;
    return (num = isNumber(num) ? num + val : val);
}

function isActiveWeekday(date, activeDays) {
    const dayOfWeekName = moment(date).locale("en").format("dddd").toUpperCase(); // Get weekday name in uppercase (English locale)
    return activeDays.includes(dayOfWeekName);
}

function getDaysBetween(startDate, endDate, activeDays) {
    let currentDate = moment(startDate);
    let discountDaysCount = 0;

    while (currentDate.isBefore(endDate)) {
        if (isActiveWeekday(currentDate, activeDays)) {
            discountDaysCount++;
        }
        currentDate.add(1, "day");
    }

    return discountDaysCount;
}

export function getDiscountAmount({
    amount,
    fullPaymentForFirstDay,
    discountAmount,
    type,
    dateRange = {},
    activeDays = [],
}) {
    const { startDate, endDate } = dateRange;

    const firstDiscountDate = moment(startDate);
    if (fullPaymentForFirstDay) firstDiscountDate.add(1, "day");

    const discountDaysCount = getDaysBetween(firstDiscountDate, moment(endDate), activeDays);
    const totalDays = moment(endDate).diff(moment(startDate), "days");

    const dailyPrice = amount / totalDays;
    const totalDiscountedDays = dailyPrice * discountDaysCount;

    const discount =
        type === "PERCENT"
            ? totalDiscountedDays * (discountAmount / 100)
            : discountAmount * discountDaysCount;

    const discountedAmount = amount - discount;
    return Math.round(discountedAmount);
}

export function getNutirationText(rate, t) {
    if (!rate?.nutrition) return t("FOOD_IS_NOT_INCLUDED_IN_THE_PRICE");
    else if (rate.allInclusive) return t("ALL_INCLUSIVE");
    else if (rate.breakfast && rate.dinner)
        return t("BREAKFAST_AND_DINNER_ARE_INCLUDED_IN_THE_PRICE");
    else if (rate.breakfast) return t("BREAKFAST_IS_INCLUDED_IN_THE_PRICE");
    else if (rate.dinner) return t("DINNER_IS_INCLUDED_IN_THE_PRICE");
}

export function numberPrettier(value = "") {
    value = String(value).trim();
    const numericValue = value.replace(/[^0-9.]/g, "");
    const [integerPart, decimalPart] = numericValue.split(".");

    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

    return decimalPart !== undefined
        ? `${formattedIntegerPart}.${decimalPart}`
        : formattedIntegerPart;
}

export function isValidEmail(email) {
    return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
    );
}

export const getServicePrice = (service, howManyDays, howManyGuests) => {
    let price = service.price;
    if (service.priceForDay) price *= howManyDays;
    if (service.priceForPerson) price *= howManyGuests;

    return price;
};
